import { AppConstant } from 'src/app/_Core/_Constants/app.constant';
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class LoggedInAuthGuard implements CanActivate {

  constructor(private _router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const url = state.url;

    if (localStorage.getItem(AppConstant.localStorage.token) !== null && localStorage.getItem(AppConstant.localStorage.token) !== 'token' && localStorage.getItem(AppConstant.localStorage.token) !== '' && !url.includes('type=resetPwd')) {
      this._router.navigateByUrl('/overview');
      return false;
    } else {
      return true;
    }
  }
}
